export const isAddressEq = (a, b) => a.toLowerCase() === b.toLowerCase();
